import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m10.68 7.016-5.8 5.674-1.575-1.575 4.097-4.099L3.304 2.92l1.577-1.576 5.798 5.673Z"
      fill="#404146"
    />
  </svg>
);

export default SvgComponent;
